<template>
  <collapse-default :id="`registro_anterior_${ordem}`"
                    :collapse-visible="collapseVisible"
                    :condition="registrosAnteriores.length">
    <template v-slot:header>
      Registros Anteriores {{ !registrosAnteriores.length ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <registros-anteriores-resultados v-if="registrosAnteriores.length"
                                       :prop-radio="false"
                                       :prop-vinculado="true"
                                       :prop-just-show="true"
                                       :prop-resultados="registrosAnteriores" />
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"
  import RegistrosAnterioresResultados from "@/components/SofiaRei/RegistrosAnteriores/RegistrosAnterioresResultados"

  export default {
    name: "RegistrosAnteriores",
    components: {
      CollapseDefault,
      RegistrosAnterioresResultados
    },
    props: {
      registrosAnteriores: {
        type: Array,
        default: () => ([])
      },
      collapseVisible: {
        type: Boolean,
        default: false
      },
      ordem: {
        type: Number,
        default: 1
      }
    },
  }
</script>

<style scoped>

</style>
